import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Active tab stored in a URL search param (Insights useTabParam): shareable, refresh-stable,
 * Back/Forward friendly. Unknown values fall back to `defaultId`, which is never written.
 */
const useTabParam = (validIds, defaultId, paramName = 'tab') => {
  const [searchParams, setSearchParams] = useSearchParams();

  const raw = searchParams.get(paramName);
  const activeTab = validIds.includes(raw) ? raw : defaultId;

  const setActiveTab = useCallback((id) => {
    const next = new URLSearchParams(searchParams);
    if (id === defaultId) next.delete(paramName);
    else next.set(paramName, id);
    setSearchParams(next);
  }, [searchParams, setSearchParams, defaultId, paramName]);

  return [activeTab, setActiveTab];
};

export default useTabParam;
